// extracted by mini-css-extract-plugin
export default {"flex":"TableLabelTop_flex__gvOBD"};